import { pipe } from './pipe';
export function createPipe() {
    var operations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        operations[_i] = arguments[_i];
    }
    return function (value) { return pipe.apply(void 0, [value].concat(operations)); };
}
